<template>
  <v-container fluid>
    <!-- DESKTOP TITLE -->
    <v-row class="d-none d-lg-flex mx-16 px-16">
      <v-col cols="12">
        <span class="text-primary text-h1 font-weight-bold">{{ $t('testimonials.title') }}</span>
      </v-col>
    </v-row>

    <!-- MOBILE TITLE -->
    <v-row class="d-lg-none">
      <v-col cols="12" class="text-center">
        <span class="text-primary text-h4 font-weight-bold">{{ $t('testimonials.title') }}</span>
      </v-col>
    </v-row>

    <!-- DESKTOP CONTENT -->
    <div class="d-none d-lg-block">
      <!-- EDIRIO -->
      <v-card width="80%" class="elevation-0 mt-8 mb-8 mx-auto">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="mx-12 px-12 text-h1 font-weight-black text-secondary">“</span><br />
              <div class="mx-16 px-16 mt-n12 text-justify">
                <span class="font-weight-bold text-h6" style="color:#052A59; font-family:Montserrat !important;">
                  {{ $t('testimonials.edirio') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row justify="end" no-gutters>
            <v-col cols="12" md="3" class="mx-12 px-12">
              <v-card class="elevation-0">
                <v-img
                  src="@/assets/portfolio/edirio.png"
                  cover
                  style="cursor:pointer;"
                  @click="openWindow('https://www.edirio.pt/')"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider />

      <!-- E-LOCAL -->
      <v-card width="80%" class="elevation-0 mt-8 mb-8 mx-auto">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="mx-12 px-12 text-h1 font-weight-black text-secondary">“</span><br />
              <div class="mx-16 px-16 mt-n12 text-justify">
                <span class="font-weight-bold text-h6" style="color:#052A59; font-family:Montserrat !important;">
                  {{ $t('testimonials.elocal') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row justify="end" no-gutters>
            <v-col cols="12" md="3" class="mx-12 px-12">
              <v-card class="elevation-0 mt-8">
                <v-row>
                  <v-col cols="12">
                    <span
                      @click="openWindow('https://e-local.pt/')"
                      class="text-h4 font-weight-bold mr-2"
                      style="cursor:pointer; float:right;"
                    >
                      E-Local
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span
                      @click="openWindow('https://e-local.pt/')"
                      class="mr-2 mt-n8"
                      style="cursor:pointer; float:right;"
                    >
                      www.e-local.pt
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- MOBILE CONTENT -->
    <div class="d-lg-none">
      <!-- EDIRIO -->
      <v-card width="80%" class="elevation-0 mt-8 mx-auto">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="text-h1 font-weight-black text-secondary">“</span><br />
              <div class="mt-n12">
                <span class="font-weight-bold text-h6" style="color:#052A59; font-family:Montserrat !important;">
                  {{ $t('testimonials.edirio') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row justify="end" no-gutters>
            <v-col cols="12" md="3">
              <v-card class="elevation-0">
                <v-img
                  src="@/assets/portfolio/edirio.png"
                  cover
                  style="cursor:pointer;"
                  @click="openWindow('https://www.edirio.pt/')"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-divider />

      <!-- E-LOCAL -->
      <v-card width="80%" class="elevation-0 mt-8 mb-8 mx-auto">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span class="text-h1 font-weight-black text-secondary">“</span><br />
              <div class="mt-n12">
                <span class="font-weight-bold text-h6" style="color:#052A59; font-family:Montserrat !important;">
                  {{ $t('testimonials.elocal') }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row justify="end" no-gutters>
            <v-col cols="12" md="3">
              <v-card class="elevation-0 mt-8">
                <v-row>
                  <v-col cols="12">
                    <span
                      @click="openWindow('https://e-local.pt/')"
                      class="text-h4 font-weight-bold mr-2"
                      style="cursor:pointer; float:right;"
                    >
                      E-Local
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span
                      @click="openWindow('https://e-local.pt/')"
                      class="mr-2 mt-n8"
                      style="cursor:pointer; float:right;"
                    >
                      www.e-local.pt
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script setup>
function openWindow(link) {
  window.open(link, '_blank')
}
</script>
